"use strict";

require("core-js/modules/es.array.reduce.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.NUMBER_REGEX = exports.INITIAL_VALUES = exports.FIELDS = exports.EXPIRY_DATE_FORMAT = exports.CVV_MAXLENGTH = exports.CREDIT_CARD_NAME_REGEX = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var EXPIRY_DATE_FORMAT = 'MM/yy';
exports.EXPIRY_DATE_FORMAT = EXPIRY_DATE_FORMAT;
var TRANSLATION = {
  // Current error text in payment page, only used if passed via prop
  cardNumberInvalid: '',
  cardExpiryDateInvalid: '',
  cardCvvInvalid: '',
  cardHolderNameInvalid: '',
  cardNumber: 'Card number',
  expiryDate: 'Expiry date (MM/YY)',
  cvv: 'CVC/CVV',
  cardholderName: 'Cardholder’s Name',
  alphabetError: 'Please use English characters (A to Z) only. Special characters or symbols are not allowed.',
  requiredError: 'Field is empty',
  expiredCardError: 'Credit Card is expired',
  defaultCard: 'Set as Default Card',
  invalid: 'Invalid expiry date',
  invalidCvv: 'Invalid CVC/CVV',
  invalidCardNumber: 'Invalid Card Number',
  saveCardCheckbox: 'Save this card to my account',
  cardAcceptedMessage: 'NOTE: We only accept Visa and Mastercard',
  processingFee: 'Processing fee',
  defaultCardConfirmationModal: {
    headingText: 'Set as default payment',
    preferredPaymentConfirmation: 'We will update your account to use this card as the default card for payments.',
    preferredPaymentConfirmationWithCardDetails: 'We will update your account to use {0} ending {1} as the default card for payments.',
    primaryButtonText: 'Confirm',
    secondaryButtonText: 'Cancel'
  },
  defaultCardInfoModal: {
    headingText: 'What is default payment',
    mainText: "We'll make this your default payment method for all airasia products & services.\n       For example, express checkout, default payment checkout and many more."
  }
};
exports.TRANSLATION = TRANSLATION;
var CVV_MAXLENGTH = 3;
exports.CVV_MAXLENGTH = CVV_MAXLENGTH;
var FIELDS = {
  cardNumber: {
    label: TRANSLATION.cardNumber,
    name: 'cardNumber'
  },
  cardholderName: {
    label: TRANSLATION.cardholderName,
    name: 'cardholderName'
  },
  expiryDate: {
    label: TRANSLATION.expiryDate,
    name: 'expiryDate'
  },
  cvv: {
    label: TRANSLATION.cvv,
    name: 'cvv'
  }
};
exports.FIELDS = FIELDS;

var INITIAL_VALUES = _objectSpread({}, Object.keys(FIELDS).reduce(function (acc, curr) {
  acc[curr] = '';
  return acc;
}, {}));

exports.INITIAL_VALUES = INITIAL_VALUES;
var CREDIT_CARD_NAME_REGEX = /^[A-Za-z ñÑ]+$/;
exports.CREDIT_CARD_NAME_REGEX = CREDIT_CARD_NAME_REGEX;
var NUMBER_REGEX = /^[0-9]+$/;
exports.NUMBER_REGEX = NUMBER_REGEX;